<div class="card card-container">
  <h2 class='login_title text-center'>Вход</h2>
  <hr>
  
  <ng-container *ngIf="mode === 'cross-login' && !authenticated">
    <p>Выполняется вход в панель управления...</p>
  </ng-container>
  
  <ng-container *ngIf="mode === 'cross-auth'">
    <p>{{ statusMessage }}</p>
    <div *ngIf="!authenticated" class="text-center" style="margin-top: 20px;">
      <div class="spinner-border" role="status">
        <span class="sr-only">Загрузка...</span>
      </div>
    </div>
  </ng-container>
</div>
